import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, TrashIcon, EditIcon, AddIcon, ViewIcon, CheckGreenIcon, CloseIcon } from 'assets/icons';
import ModalCreate from './modal-create';
import { MissionService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	type: '',
	status: '',
	date: ''
}

class AdminMissions extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Fecha de Creación',
			'Tipo',
			'Puntos',
			'Validez',
			'Días Antes',
			'Estatus',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Misiones',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await MissionService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD')
		});
		this.setState({
			data: res.missions.rows,
			last_page: res.missions.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_view: true,
			item
		});
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la misión?',async () => {
			await MissionService.admin.delete({
				mission_id: item.id
			});
			this.load(true);
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => {
			this.load(true);
		});
	}
	
	getColor = (status: number) => {
		switch(status) {
			case Constants.MISSION_STATUS.ACTIVE:
				return Colors.green;
			break;

			case Constants.MISSION_STATUS.INACTIVE:
				return Colors.danger;
			break;
		}
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="admin-missions">
		      	<Modal
		          className="modal-create-mission"
		          visible={ visible }
		          title={ `${ this.state.item ? 'Editar' : 'Crear' } misión` }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		            item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-3">
								<DatePicker
									label="Fecha de creación"
									placeholder="Fecha"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'date'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.date }
								/>
							</div>
							<div className="col-md-3">
								<Select
									placeholder="Seleccionar"
									label="Tipo de Misión"
									name="type"
									color="white"
									onChange={ (e: any) => this.change(e,() => this.load(true)) }
									value={ this.state.form.type }
									options={ [
										{ value: Constants.MISSION_TYPES.DAYS_BEFORE.toString(), label: 'Pagar días antes' },
										{ value: Constants.MISSION_TYPES.DAY.toString(), label: 'Pagar un día especifico' },
									] } />
							</div>
							<div className="col-md-3">
								<Select
									placeholder="Seleccionar"
									label="Estatus"
									name="status"
									color="white"
									onChange={ (e: any) => this.change(e,() => this.load(true)) }
									value={ this.state.form.status }
									options={ [
										{ value: Constants.MISSION_STATUS.ACTIVE.toString(), label: 'Activas' },
										{ value: Constants.MISSION_STATUS.INACTIVE.toString(), label: 'Inactivas' },
									] } />
							</div>
							<div className="col-md-1">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Misiones" data={ this.state.data.length } header={ this.state.header } titleRight={
					<>
						{
							checkPermission(Constants.MODULES.MISSIONS,'write') && (
								<div className="container-add-table">
									<p>Nuevo</p>
									<button className="btn add-btn-table" onClick={ () => this.add() }>
										<img src={ AddIcon } />
									</button>
								</div>
							)
						}
					</>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i.created_at).format('DD/MM/YYYY') }</td>
								<td>{ i.type_text }</td>
								<td>{ i.points }</td>
								<td>{ i.type == Constants.MISSION_TYPES.DAYS_BEFORE ? `${ moment(i.since).format('DD/MM/YYYY') } - ${ moment(i.until).format('DD/MM/YYYY') }` : moment(i.date).format('DD/MM/YYYY') }</td>
								<td>{ i.days_before || '-' }</td>
								<td className="status" style={{ color: this.getColor(i.status) }}>{ i.status_text }</td>
								<td>
									{
										checkPermission(Constants.MODULES.MISSIONS,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.MISSIONS,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(AdminMissions);